import { connectFela } from '../../../../dependencies';
import FakturoidService from './FakturoidService';
import * as styles from './FakturoidService.styles';

export default connectFela(styles)(FakturoidService);
